import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/incomingMails/'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET = NAMESPACE + 'SET'

const initialState = {
  names: [],
  byName: {}
}

export const incomingMailDefaults = {
  name: '',
  boardId: null,
  cardId: null,
  validateAddress: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState
      }
    case ADD: {
      const newState = {
        ...state,
        byName: { ...state.byName }
      }
      newState.names = addUniqueValueToArray({
        array: newState.names,
        value: action.payload.name
      })
      newState.byName[action.payload.name] = {
        ...incomingMailDefaults,
        ...state.byName[action.payload.name],
        ...action.payload
      }
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        names: state.names.filter(name => name !== action.payload.name),
        byName: { ...state.byName }
      }
      delete newState.byName[action.payload.name]
      return newState
    }
    case SET:
      return state.byName[action.payload.name] ? {
        ...state,
        byName: {
          ...state.byName,
          [action.payload.name]: {
            ...state.byName[action.payload.name],
            ...action.payload
          }
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function remove ({ name }) {
  return {
    type: REMOVE,
    payload: {
      name
    }
  }
}

export function set ({ name, ...data }) {
  return {
    type: SET,
    payload: {
      name,
      ...data
    }
  }
}